export class IdentityConstants {
  public static AdminRoleName = 'Admin';
  public static OrgManagerRoleName = 'OrganizationManager';
  public static TerminalManagerRoleName = 'TerminalManager';
  public static SafetyManagerRoleName = 'SafetyManager';
  public static DriverRoleName = 'Driver';
}
